module.exports = __webpack_public_path__ + "img/2012-08-18 17.18.54.9b905ac5.jpg";